<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Adicionar Notícia</h3>
          </div>
          <NewsForm :news="news" :errors="errors" :onSubmit="onSubmit"></NewsForm>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import NewsClient from '@/services/resource_client/news'
import NewsForm from '@/pages/news/NewsForm'

export default {
  name: 'CreateNews',
  components: { Adminlte, NewsForm },
  data: function () {
    return {
      news: {},
      errors: {}
    }
  },
  methods: {
    onSubmit () {
      NewsClient.post(this.news)
      .then(r => { this.$router.push({ name: 'NewsHome' }) })
      .catch(e => { this.errors = e.response.data.errors })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateNews.vue?27cbbbcf